module.exports = __webpack_public_path__ + "static/media/home_tisane.1dc764a0.png";